module.exports = __webpack_public_path__ + "img/tour-13.fe642089.png";